<template>
  <div>
    <!--<div class="sidenav-overlay"></div>-->
    <!--<div class="drag-target"></div>-->
    <footer class="footer footer-light">
      <p class="clearfix mb-0"><span class="float-md-left d-block d-md-inline-block mt-25">COPYRIGHT &copy; {{new Date().getFullYear()}}<router-link to="/"><a
          class="ml-25" target="_blank">VaultsPay</a></router-link><span
          class="d-none d-sm-inline-block">, All rights Reserved</span></span></p>
    </footer>
<!--    <button class="btn btn-primary btn-icon scroll-top" type="button"><i data-feather="arrow-up"></i></button>-->
  </div>
</template>

<script>
export default {
  mounted() {
  },
  data() {
    return {}
  }
}
</script>

